import { staticText } from "../../statics/static-text";

// TEXT
export const text = staticText.copyLink;

// STYLES

// DATA

// TYPES
export interface CopyLinkProps {
  link: string;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
